<script lang="ts" setup>
import { type ComMessage } from "@/model/communication/com-message"
import { $datetime } from "@/vf"
import { ref, toRefs } from "vue"
import { type TasksProps } from "./tasks-props"

const props = defineProps<TasksProps<ComMessage>>()

const { task, index } = toRefs(props)

function initials(name: string) {
    return (
        name
            ?.split(" ")
            .map(n => n[0])
            .join("")
            .toUpperCase()
            .substring(0, 2) ?? ""
    )
}

const footerOpen = ref(false)
</script>

<template>
    <div>
        <div class="p-4 d-flex align-items-center">
            <div class="pr-3" v-if="index > 0">
                <i class="fa fa-fw fa-reply fa-rotate-180 fa-2x text-primary"></i>
            </div>
            <div class="pr-3">
                <div class="rounded-circle bg-primary d-flex" style="width: 4rem; height: 4rem">
                    <h1 class="m-auto text-white">{{ initials(task.participantName) }}</h1>
                </div>
            </div>
            <div class="flex-grow-1">
                <div>{{ $datetime(task.createdAt) }}</div>
                <div>
                    {{ task.participantName }} via
                    <span v-if="task.source === 'portal'">My Varsity</span>
                    <span v-if="task.source === 'office'">My Office</span>
                    <span v-if="task.source === 'contact'">Kontaktformular</span>
                    <span v-if="task.source === 'mail'">E-Mail</span>
                </div>
                <div class="small text-danger" v-if="task.internal">{{ $t("@communication:internal_message") }}</div>
            </div>
            <div v-if="task.attachments?.length">
                <i class="fa fa-fw fa-paperclip fa-2x"></i>
            </div>
        </div>

        <div class="card-body">
            <div style="white-space: pre-line" v-if="!task.isHtml">{{ task.text }}</div>
            <div v-html="task.text" v-else></div>

            <div v-if="task.textFooter">
                <a href="javascript:void(0)" @click="footerOpen = true" v-if="!footerOpen">
                    {{ $t("@communication:signature") }}
                </a>
                <div v-if="footerOpen">
                    <div style="white-space: pre-line" v-if="!task.isHtml">{{ task.textFooter }}</div>
                    <div v-html="task.textFooter" v-else></div>
                </div>
            </div>
        </div>
    </div>
</template>
